<!-- LOGICAL OPERATOR -->

@if (condition.conditions.length > 1) {
  <div class="operator">
    <mat-form-field>
      <mat-label>Operator</mat-label>
      <mat-select [(ngModel)]="condition.operator">
        @for (operator of logicalOperators; track operator) {
          <mat-option [value]="operator.key">{{ operator.value.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}

<!-- SUBCONDITIONS -->

<div class="subconditions">
  @for (subcondition of condition.conditions; track condition) {
    <div class="subcondition">
      @if (condition.conditions.length > 1) {
        <button mat-icon-button aria-label="Remove condition" (click)="removeSubCondition(subcondition)" matTooltip="Remove condition">
          <mat-icon>close</mat-icon>
        </button>
      }
      @if (subcondition.type === 'simple') {
        <tyt-simple-condition-editor [condition]="subcondition" />
      } @else if (condition.type === 'complex') {
        <tyt-condition-editor [condition]="subcondition" />
      }
    </div>
  }

  <div class="controls">
    <button mat-raised-button (click)="addSimpleSubCondition()">
      <mat-icon>add</mat-icon>
      Add Condition
    </button>
    <button mat-raised-button (click)="addComplexSubCondition()">
      <mat-icon>add</mat-icon>
      Add Group
    </button>
  </div>
</div>